<div class="card">
    <div class="p-grid">
        <div class="p-col">
            <h4>Quill Templates</h4>
        </div>
        <div
            class="p-col"
            style="text-align: right;"
        >
            <p-button
                *hasPermission="['templates.add']"
                label="Add Template"
                icon="pi pi-plus"
                (click)="addTemplate()"
            ></p-button>
        </div>
    </div>
    <ng-container *ngIf="groupedTemplates$ | async as groupedTemplates">
        <div class="p-grid">
            <div
                class="p-col-12"
                *ngFor="let location of (groupedTemplates | keyvalue)"
            >
                <h5>{{ location.key }}</h5>
                <p-table
                    [value]="location.value"
                    [responsiveLayout]="'scroll'"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Name</th>
                            <th>Contents</th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template
                        pTemplate="body"
                        let-template
                    >
                        <tr>
                            <td width="25%">
                                {{ template.name }}
                                <br>
                                <small>({{ template?.zoneId }})</small>
                            </td>
                            <td width="60%">
                                <quill-editor
                                    class="p-mb-3"
                                    *ngIf="templatesWithSubjectContents.has(template.location)"
                                    [modules]="{toolbar: [], variableToolbar: true}"
                                    [ngModel]="template.subjectContents"
                                    (onEditorCreated)="onEditorCreated($event,template,true)"
                                    (onContentChanged)="onContentChanged($event, template, true)"
                                    format="object"
                                ></quill-editor>
                                <quill-editor
                                    [modules]="modules"
                                    [ngModel]="template.contents"
                                    (onEditorCreated)="onEditorCreated($event, template)"
                                    (onContentChanged)="onContentChanged($event, template)"
                                    format="object"
                                ></quill-editor>
                            </td>
                            <td width="15%">
                                <div
                                    class="content-action-buttons"
                                    *ngIf="(templateContentEdits$ |async)[template.id]; else standardActionButtons"
                                >
                                    <span>Template contents changed!</span>
                                    <div class="action-buttons p-mt-3">
                                        <p-button
                                            icon="pi pi-save"
                                            (click)="saveTemplateChanges(template)"
                                            class="p-mb-2"
                                        ></p-button>
                                        <p-button
                                            [outlined]="true"
                                            severity="danger"
                                            icon="pi pi-times"
                                            (click)="discardTemplateChanges(template)"
                                            class="p-mb-2"
                                        ></p-button>
                                    </div>
                                </div>
                                <ng-template #standardActionButtons>
                                    <div class="action-buttons">
                                        <p-button
                                            *hasPermission="['templates.update']"
                                            icon="pi pi-pencil"
                                            (click)="editTemplate(template)"
                                        ></p-button>
                                        <p-button
                                            *hasPermission="['templates.delete']"
                                            icon="pi pi-trash"
                                            (click)="deleteTemplate(template)"
                                        ></p-button>
                                        <p-button
                                            pTooltip="Click on the star to set this template as default for this location"
                                            [text]="true"
                                            severity="warning"
                                            (click)="setDefaultTemplate(template, location.value)"
                                            [icon]="(template.isDefault ? 'pi pi-star-fill' : 'pi pi-star')"
                                        />
                                    </div>
                                </ng-template>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="4">
                                No templates found for this location.
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div
            *ngIf="groupedTemplates && (groupedTemplates | keyvalue).length === 0"
            class="empty-message"
        >
            No templates found.
            <p-button
                *hasPermission="['templates.add']"
                label="Create New Template"
                icon="pi pi-plus"
                class="p-ml-2"
                (click)="addTemplate()"
            ></p-button>
        </div>
    </ng-container>
</div>